import { useRef } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { Button, Card, Input } from "../primitives";
import { useOutletContext } from "react-router-dom";
import useTimedError from "../../hooks/useTimedError";
import { useTranslation } from "../../hooks/useTranslation";

export default function Reauthenticate({ setIsReauthed, setIsOpen }) {

    const t = useTranslation();
    const passwordRef = useRef();
    const { reauth, getAuthProvider } = useAuth();
    const [error, setError] = useTimedError();

    async function handleReauth(providerType, isPassword) {
        try {
            await reauth(providerType, isPassword ? passwordRef.current.value : null);
            setIsReauthed(true); 
        } catch (error) {
            console.log(error);
            if (isPassword) {
                setError(t("Invalid password."));
            }
            else {
                window.dispatchEvent(new CustomEvent('masterError', {
                    detail: {
                        message: error.message
                    }
                }));
            }
        }
    }

    function getButton(providerType, isPassword = false) {
        return (<>
            <Button 
                onClick={() => handleReauth(providerType, isPassword)} 
                buttonType="submit" 
                error={error}
            >
                {error?.message || t("Confirm")}
            </Button>
            <Button onClick={() => setIsOpen(false)}>{t('Cancel')}</Button>
        </>);
    }

    function getProviderComponent() {
        switch(getAuthProvider()) {
            case "google.com":
                return <>
                    {getButton("google.com")}
                </>;
            case "microsoft.com":
                return <>
                    {getButton("microsoft.com")}
                </>;
            case "password":
                return <>
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        handleReauth("password", true);
                    }}>
                        <Input type="password" ref={passwordRef} labelText={t('Password')} />
                        <Button
                            buttonType="submit" 
                            error={error}
                        >
                            {error || t("Confirm")}
                        </Button>
                    </form>
                    <Button onClick={() => setIsOpen(false)}>{t('Cancel')}</Button>
                    <a href="/forgot-password">{t('Forgot password?')}</a>
                </>;
            default:
                window.dispatchEvent(new CustomEvent('masterError', {
                    detail: {
                        message: t("Invalid provider")
                    }
                }));
                setIsOpen(false);
                return;
        }
    }

    return (
        <Card ctype="white">
            <Card.Header>
                <h2>{t('Please reauthenticate.')}</h2>
            </Card.Header>
            <Card.Body>
                {getProviderComponent()}
            </Card.Body>
        </Card>
    )
}